import { styled } from "@mui/material";
import { Row } from "./Row";

export const ActionButtonRow = styled(Row)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
  justifyContent: "flex-end",
}));
